export default __webpack_public_path__ + "static/media/2.VERIFICACION_ESTERILIZACION_SFS.ad1a98cd.mp4";